import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

// Components

import UniversalInput from '@lib/wrappers/UniversalInput';

// Constants

import { configs } from '@constants/configs/configs';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';

// Types

import { SsapData } from '@components/ssap/SsapTypes';

interface IReceivedNoticeOfRightsAttestation {
    actions: {
        onFieldChange_data: Function
    },
    data: SsapData,
    formName: string
}

const ReceivedNoticeOfRightsAttestation = (props: IReceivedNoticeOfRightsAttestation): ReactElement => {
    const {
        actions: {
            onFieldChange_data
        },
        data,
        data: {
            legalAttestations: {
                receivedNoticeOfRights
            }
        },
        formName
    } = props;

    return (
        <UniversalInput
            label = { {
                labelClass: [ 'required-true' ],
                text: 'ssap.input.label.received_notice_of_rights',
                labelTextReplacements: {
                    link: (
                        <a
                            className = 'usa-link--external'
                            href = { configs.externalEndpoints.MN_LINKS.CUSTOMER_RIGHTS }
                            target = '_blank'
                            rel = 'noopener noreferrer'
                        >
                            <FormattedMessage id = 'ssap.sign_and_review.rights_and_responsibilities_link_anchor'/>
                        </a>
                    )
                }
            } }
            inputData = { {
                isInputRequired: true,
                classes: [ 'disp-styl' ],
                type: INPUT_TYPES.CHECKBOX,
                name: 'receivedNoticeOfRights',
                checked: receivedNoticeOfRights,
                value: receivedNoticeOfRights,
                validationType: VALIDATION_TYPES.CHECKED,
                currentData: data,
                fields: [ 'legalAttestations' ]
            } }
            errorClasses = { [ 'margin-l-0' ] }
            inputActions = { {
                onFieldChange: onFieldChange_data
            } }
            underFormControl
            parentForm = { { name: formName } }
        />
    );
};

export default ReceivedNoticeOfRightsAttestation;